import React from 'react'
import "./Contact.css";
import logo from "../../slike/co.png";
export default function Contact() {
  return (
    <div className='contact'>
          <div className='productsContainer' style={{marginTop:'3%'}}>
        <p className='h2'>CONTACT </p>
      </div>
      <div className='contact2'>
        <div className='ContactSlikaDiv'>
          <img src={logo} alt='nema slike'className='LogoContact'/>
          <div className='contactText'>
          <p className="prvo" style={{fontFamily:"Exo2-Medium", marginTop:"80px"}}>For question about our products and services, contact our sales department:</p>
          <p className="drugo" style={{fontFamily:"Exo2-Medium", marginBottom:"45px"}}>+381 (0) 230 590 590</p>
          <p className="trece" style={{fontFamily:"Exo2-Medium", marginBottom:"15px"}}>info@modular-parts-system.rs</p>
          <p className="cetvrto" style={{fontFamily:"Exo2-Medium", marginBottom:"31px"}}>sales@modular-parts-system.rs</p>
          <p className="peto2"style={{fontFamily:"Exo2-Medium", display:"none"}}>Cara Dusana 170, &nbsp; 23300 Kikinda,Serbia</p>
          <p className="peto"style={{fontFamily:"Exo2-Medium"}}>Cara Dusana 170,23300 Kikinda,Serbia</p>
          <p className="sesto"style={{fontFamily:"Exo2-Medium"}}>MPS Modular Parts System DOO</p>
        </div>
        </div>
      </div>
    </div>
  )
}
